import { FacturasList } from "./FacturasList"

export { FacturasList }

export function FacturasLizenList() {
  return <FacturasList origen="lizen" />
}

export function FacturasOrionList() {
  return <FacturasList origen="orion" />
}
